import React from 'react'
import { Icon } from 'loyal-react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import CategorySubMenuItem from '../CategoryMenu/CategorySubMenuItem'
import yn from 'yn'

const MenuItem = ({
  label,
  path,
  icon,
  checked,
  categoryId,
  indexItem,
  indexParent,
  subCategoryId,
  campaingId,
  type,
  enabled,
  hide,
  className,
  parentClassName,
  hasItems,
  showSubmenu,
  onBlurLink,
  externalLink
}) => {
  return (
    hasItems ? (
      <div className={`row mx-0 ${parentClassName} item-with-submenu ${checked ? 'item-checked' : ''}`}>
        <div className='col'>
          <button
            onClick={() => showSubmenu(`${type}_${indexParent}_${indexItem}`)}
            onKeyPress={(event) => event.key === 'Enter' && showSubmenu(`${type}_${indexParent}_${indexItem}`)
            }
            data-href={path}
            className={`link-profile txt-font-body txt-body-sm d-block px-1 py-1 ${className}`}
            aria-expanded={checked}
            aria-controls={`submenu-${type}_${indexParent}_${indexItem}`}
          >
            {label}
          </button>
        </div>
        <div className='col-auto pr-1'>
          <Icon iconName='icon_right' className='icon-sm' />
        </div>
      </div>
    ) : label === 'Verificação em Duas Etapas' ? (
      <div className={`row mx-0 ${parentClassName}`}>
        <div className='col'>
          <a
            href={path}
            className={`link-profile txt-font-body txt-body-sm d-block px-1 py-1 ${className}`}
          >
            {label}
          </a>
        </div>
      </div>
    ) : type === 'category' ||
      type === 'sub-category' ||
      type === 'services' ||
      type === 'services-external' ? (
        <CategorySubMenuItem
          type={type}
          path={path}
          label={label}
          categoryId={categoryId}
          subCategoryId={subCategoryId}
          enabled={enabled}
          className={`${className}`}
          parentClassName={parentClassName}
          hasItems={hasItems}
        />
      ) : label === 'Minhas viagens' ? (
        (process.env.REACT_APP_CATALOG_ID === '40542' ||
        process.env.REACT_APP_CATALOG_ID === '40541' ||
        process.env.REACT_APP_CATALOG_ID === '40540' ||
        process.env.REACT_APP_CATALOG_ID === '40539' ||
        process.env.REACT_APP_CATALOG_ID === '40538' ||
        process.env.REACT_APP_CATALOG_ID === '40543') && (
          <div className={`row mx-0 ${parentClassName}`}>
            <div className='col'>
              <a
                href={path}
                className={`link-profile txt-font-body txt-body-sm d-block px-1 py-1 ${className}`}
              >
                {label}
              </a>
            </div>
          </div>
        )
      ) : path === '/scheduling' ? (
        (yn(process.env.REACT_APP_HAS_SCHEDULING)) && (
          <div className={`row mx-0 ${parentClassName}`}>
            <div className='col'>
              <a
                href={path}
                className={`link-profile txt-font-body txt-body-sm d-block px-1 py-1 ${className}`}
              >
                {label}
              </a>
            </div>
          </div>
        )
      ) : type === 'logout' ? (
        <div className={`row mx-0 ${parentClassName}`}>
          <div className='col'>
            <a
              href={path}
              className={`link-profile txt-font-body txt-body-sm d-block px-1 py-1 ${className}`}
              onBlur={() => onBlurLink()}
            >
              {label}
            </a>
          </div>
        </div>
      ) : externalLink ? (
        !hide && (<div className={`row mx-0 ${parentClassName}`}>
          <div className='col'>
            <a
              href={path}
              className={`link-profile txt-font-body txt-body-sm d-block px-1 py-1 ${className}`}
              onBlur={() => onBlurLink()}
              aria-label={label}
            >
              {label}
            </a>
          </div>
        </div>)
      ) : (
        <div className={`row mx-0 ${parentClassName}`}>
          <div className='col'>
            <Link
              to={path == null ? '/' : path}
              className={`link-profile txt-font-body txt-body-sm d-block px-1 py-1 ${className}`}
            >
              {label}
            </Link>
          </div>
          {icon ? (
            <div className='col-auto pr-1 my-auto'>
              <Icon iconName='icon_right' className='icon-sm' />
            </div>
          ) : (
            ''
          )}
        </div>
      )
  )
}

MenuItem.propTypes = {
  label: PropTypes.string.isRequired,
  path: PropTypes.string.isRequired,
  checked: PropTypes.bool,
  icon: PropTypes.bool,
  categoryId: PropTypes.number,
  indexItem: PropTypes.number,
  indexParent: PropTypes.number,
  subCategoryId: PropTypes.number,
  campaingId: PropTypes.any,
  type: PropTypes.string,
  enabled: PropTypes.bool,
  className: PropTypes.string,
  parentClassName: PropTypes.string,
  hasItems: PropTypes.bool,
  showSubmenu: PropTypes.func,
  onBlurLink: PropTypes.func,
  hide: PropTypes.bool,
  externalLink: PropTypes.bool
}
MenuItem.defaultProps = {
  className: ''
}
export default MenuItem



// WEBPACK FOOTER //
// ./src/App/MainMenu/MenuItem/MenuItem.js